import React from 'react'
import styled from 'styled-components'

import {mediaQueries} from "../shared/config"

export default function PhotoWithCredits(props) {
    return (
        <Container>
            <Photo src={props.link} />
            <Credits>
                {props.credits}
            </Credits>
        </Container>
    )
}

const Container = styled.div`
    margin: 0 100px;
    ${mediaQueries.mobile} {
		margin: 0 45px;
	}
`

const Photo = styled.img`
    width: 100%;
    height: auto;
`

const Credits = styled.p`
    display: block;
    width: 100%;
    text-align: right;
    font-family: Quicksand;
    font-style: normal;
    font-weight: bold;
    margin: 0;
    color: white;
    margin-right: 20px;
    font-size: 14px;
    ${mediaQueries.mobile} {
        font-size: 10px;
    }
`